import { dispatchConnectedToolkitsChanged } from './sessionToolkits.js'
import { SETTINGS_DISMISSED_CONNECTION_IDS_KEY } from './keys.js'

export function readDismissedConnectionIds() {
  if (typeof sessionStorage === 'undefined') return []
  try {
    const raw = sessionStorage.getItem(SETTINGS_DISMISSED_CONNECTION_IDS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map((s) => String(s || '').trim()).filter(Boolean)
  } catch {
    return []
  }
}

export function addDismissedConnectionId(accountId) {
  const id = String(accountId || '').trim()
  if (!id || typeof sessionStorage === 'undefined') return
  try {
    const cur = readDismissedConnectionIds()
    if (!cur.includes(id)) cur.push(id)
    sessionStorage.setItem(SETTINGS_DISMISSED_CONNECTION_IDS_KEY, JSON.stringify(cur))
    dispatchConnectedToolkitsChanged()
  } catch {
    /* quota */
  }
}
